import * as React from 'react';

import { Link } from '../Link';

import * as styles from './BottomStripe.css';
import * as gridStyles from '../../utils/grid.css';

interface IBottomStripeProps {
  withSiteTypeChanging: boolean;
  onSiteTypeChange(event: React.MouseEvent<HTMLAnchorElement>): void;
}

export const BottomStripe: React.FC<IBottomStripeProps> = ({ withSiteTypeChanging, onSiteTypeChange }) => {
  const year = new Date().getFullYear();
  // TODO сделать так чтобы на node и в браузере год всегда совпадал. Не нужно чтобы год зависел от настроек ОС пользака

  return (
    <div className={styles['c-footer-blackstripe']}>
      <div className={gridStyles['cg-container-fluid-xs']}>
        <div className={gridStyles['cg-row']}>
          <div className={gridStyles['cg-col-24']}>
            <div className={styles['c-footer-copyright']}>© {year} ЦИАН ГРУПП</div>
            {withSiteTypeChanging && (
              <div className={styles['c-footer-tomobile']}>
                <Link href="/" theme="light" onClick={onSiteTypeChange}>
                  Мобильная версия сайта
                </Link>
              </div>
            )}
            <div className={styles['c-footer-age']}>16+</div>
          </div>
        </div>
      </div>
    </div>
  );
};
